module.exports = __webpack_public_path__ + "assets/img/shop_btn_get.3922366a.png";